import React, { Component } from 'react';
import muiThemeable from 'material-ui/styles/muiThemeable';

import Tabs from 'ui/Tabs';



class Header extends Component {
  
  static defaultProps = {
    tabs: [],
    actions: [],
  }
  
  render() {
    const { image, title, actions, tabs } = this.props;
    
    let imageEl = null;
    if(image && React.isValidElement(image)) {
      imageEl = (
        <div className="header-image">
          {image}
        </div>
      );
    }
    
    let tabEls = React.Children.map(tabs, (el, i) => {
      if(!React.isValidElement(el)) {
        return null;
      }
      return React.cloneElement(el, {key:i});
    });
    
    let actionsEl = null;
    if(actions.length > 0) {
      actionsEl = (
        <div className="header-actions">
          {React.Children.map(this.props.actions, (el, i) => {
            if(!React.isValidElement(el)) {
              return null;
            }
            return React.cloneElement(el, {key:i});
          })}
        </div>
      );
    }
    
    return (
      <div className="header-content">
        
        {imageEl}
        
        <div className="header-info">
          <div className="header-title">
            <div className="header-title-text">{title}</div>
            <div className="header-title-rule"></div>
          </div>
          
          <Tabs className="header-tabs">
            {tabEls}
          </Tabs>
          
          {actionsEl}
        </div>
        
        {!!imageEl && <div className="header-image-counter"/>}
      </div>
    );
  }
}

export default muiThemeable()(Header);